define([], function() {
    return {
        reverseGeocode: 'reverseGeocode',
        crossStreetLookup: 'reverseGeocode/crossStreet'
    };
});



// WEBPACK FOOTER //
// ./services/reverseGeocode/types.js